import { useCallback } from "react";
import type { MessageInfo } from "../types";
import { toast } from "react-toastify";

export const useMessageHandler = () => {
    return useCallback((info: MessageInfo) => {
        if (info.error) {
            toast.error(info.error);
        } else if (info.warning) {
            toast.warning(info.warning);
        } else if (info.message) {
            toast.success(info.message);
        }
    }, [])
};
